import { pushRoute } from '../../../lib/router.js';
import React, { useState } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import moment from 'moment';
import { getOrgTermsContent } from '../../../content/utils.js';
import CustomizeStakeholderAnalysisIcon from '../../icons/CustomizeStakeholderAnalysisIcon.jsx';
import { EditBlueIcon } from '../../icons/EditBlueIcon.jsx';
import { EditDatesIcon } from '../../icons/EditDatesIcon.jsx';
import { EyeIcon } from '../../icons/EyeIcon.jsx';
import { DeleteBlueIcon } from '../../icons/DeleteBlueIcon.jsx';
import AuthorizedAction, { isAuthorized } from '../../AuthorizedAction.js';
import SendFeedbackModal from '../../send-feedback-modal/SendFeedbackModal.jsx';
import EditChangeInsightDatesModal from '../EditChangeInsightDatesModal/index.jsx';
import MailIcon from '../../icons/MailIcon.jsx';
import { getOrgSlug } from '../../../lib/utils.js';
import { ShareIcon } from '../../icons/ShareIcon.jsx';
import DownloadReportIcon from '../../icons/DownloadReportIcon.jsx';
import {
  formatedTemplate,
  generateSurveyPDF,
  generateSurveyResponse,
} from '../../../containers/change-insights/utils/index.jsx';
import './ChangeInsightsActionDropdown.module.css';

const ChangeInsightsActionDropdown = ({
  initiative,
  initiativeId,
  initiativeType,
  loading,
  handleDeleteSurvey,
  surveyResponses,
  survey,
  permissions,
  isArchivedProject,
  handleClickSendFeedbackForm,
  handleUpdateEmailSetting,
  handleClickCopyLink,
}) => {
  const isDateAfter = moment(moment(new Date()).format('YYYY-MM-DD')).isAfter(
    moment(survey.endDate)
  );

  const [showEditDatesModal, setShowEditDatesModal] = useState(false);
  const slug = getOrgSlug();
  const handleClickChangeDates = () => {
    if (isArchivedProject) {
      window.alert(getOrgTermsContent('archivedProjectMessage'));
    } else setShowEditDatesModal(true);
  };

  const handleClickDeleteSurvey = (emailSettings) => {
    if (isArchivedProject) {
      window.alert(getOrgTermsContent('archivedProjectMessage'));
    } else if (
      window.confirm(
        'Are you sure you want to delete this feedback form? \n\nFeedback form tracking and answers will be lost. Action cannot be undone.'
      )
    )
      handleDeleteSurvey(survey.id, emailSettings);
  };

  const handleClickPreview = () => {
    window.open(`/${slug}/change-insights/surveys/${survey.id}`, '_blank');
  };

  const handleClickCustomize = () => {
    if (isArchivedProject) {
      window.alert(getOrgTermsContent('archivedProjectMessage'));
    } else {
      pushRoute('change-insights/studio/settings', {
        initiativeType,
        initiativeId,
      });
    }
  };

  const handleClickEdit = () => {
    if (isArchivedProject) {
      window.alert(getOrgTermsContent('archivedProjectMessage'));
    } else {
      pushRoute('change-insights/edit', { initiativeType, initiativeId });
    }
  };

  return (
    <div className="actions">
      <DropdownButton
        noCaret
        title=""
        id="id"
        className="btn-more btn btn-default"
      >
        {survey ? (
          <React.Fragment>
            {survey.sentAt ? (
              <AuthorizedAction
                action="update"
                subject={`${initiativeType}Initiative`}
              >
                <span className="item">
                  <MenuItem disabled={loading} onClick={handleClickCustomize}>
                    <span className="flex">
                      <CustomizeStakeholderAnalysisIcon />
                      <span>&nbsp; Customize Feedback Form Dashboard</span>
                    </span>
                  </MenuItem>
                  <MenuItem divider />
                </span>
              </AuthorizedAction>
            ) : null}

            {survey ? (
              <React.Fragment>
                <span className="item">
                  <MenuItem disabled={loading} onClick={handleClickPreview}>
                    <span className="flex">
                      <EyeIcon />
                      <span>&nbsp; Preview</span>
                    </span>
                  </MenuItem>
                  <MenuItem divider />
                </span>
                <span className="item">
                  <MenuItem
                    onClick={() =>
                      generateSurveyPDF({
                        title: survey.title,
                        surveyJson: survey.surveyJson,
                      })
                    }
                  >
                    <span className="flex">
                      <DownloadReportIcon />
                      <span>&nbsp; Download Template</span>
                    </span>
                  </MenuItem>
                  <MenuItem divider />
                </span>
              </React.Fragment>
            ) : null}

            {survey?.surveyJson && surveyResponses?.length ? (
              <React.Fragment>
                <span className="item">
                  <MenuItem
                    onClick={() =>
                      generateSurveyResponse(
                        survey.surveyJson,
                        surveyResponses,
                        'pdf',
                        initiative.title
                      )
                    }
                  >
                    <span className="flex">
                      <DownloadReportIcon />
                      <span>&nbsp; Download PDF</span>
                    </span>
                  </MenuItem>
                  <MenuItem divider />
                </span>
                <span className="item">
                  <MenuItem
                    onClick={() =>
                      generateSurveyResponse(
                        survey.surveyJson,
                        surveyResponses,
                        'xlsx',
                        initiative.title
                      )
                    }
                  >
                    <span className="flex">
                      <DownloadReportIcon />
                      <span>&nbsp; Download XLS</span>
                    </span>
                  </MenuItem>
                  <MenuItem divider />
                </span>
                <span className="item">
                  <MenuItem
                    onClick={() =>
                      generateSurveyResponse(
                        formatedTemplate(survey.surveyJson),
                        surveyResponses,
                        'csv',
                        initiative.title
                      )
                    }
                  >
                    <span className="flex">
                      <DownloadReportIcon />
                      <span>&nbsp; Download CSV</span>
                    </span>
                  </MenuItem>
                  <MenuItem divider />
                </span>
              </React.Fragment>
            ) : null}

            {!survey.sentAt ? (
              <AuthorizedAction
                action="update"
                subject={`${initiativeType}Initiative`}
              >
                <span className="item">
                  <MenuItem disabled={loading} onClick={handleClickEdit}>
                    <span className="flex">
                      <EditBlueIcon />
                      <span>&nbsp; Edit</span>
                    </span>
                  </MenuItem>
                  <MenuItem divider />
                </span>
              </AuthorizedAction>
            ) : null}
            <AuthorizedAction
              action="update"
              subject={`${initiativeType}Initiative`}
            >
              <span className="item">
                <MenuItem disabled={loading} onClick={handleClickChangeDates}>
                  <span className="flex">
                    <EditDatesIcon />
                    <span>&nbsp; Edit Feedback Dates</span>
                  </span>
                </MenuItem>
                <MenuItem divider />
              </span>
            </AuthorizedAction>

            {!survey.sentAt || survey.newRecipients ? (
              <span className="item">
                {survey && !survey.sentAt ? (
                  !isArchivedProject && !isDateAfter ? (
                    <SendFeedbackModal
                      type="link"
                      textButton="Send Feedback Form"
                      survey={survey}
                      loading={loading}
                      isCanManage
                      initiativeType={initiativeType}
                      initiative={initiative}
                      handleUpdateEmailSetting={handleUpdateEmailSetting}
                      handleClickSendFeedbackForm={handleClickSendFeedbackForm}
                    />
                  ) : (
                    <MenuItem
                      onClick={() =>
                        window.alert(
                          isArchivedProject
                            ? getOrgTermsContent('archivedProjectMessage')
                            : 'The feedback form cannot be sent to participants because its dates are in the past. Please update the start and end dates and try again.'
                        )
                      }
                    >
                      <span className="flex">
                        <MailIcon />
                        <span>&nbsp;Send Feedback Form</span>
                      </span>
                    </MenuItem>
                  )
                ) : null}
                {survey?.sentAt && survey?.newRecipients ? (
                  !isArchivedProject && !isDateAfter ? (
                    <SendFeedbackModal
                      type="link"
                      textButton="Send to New Participants"
                      survey={survey}
                      loading={loading}
                      isCanManage
                      initiativeType={initiativeType}
                      initiative={initiative}
                      handleUpdateEmailSetting={handleUpdateEmailSetting}
                      handleClickSendFeedbackForm={handleClickSendFeedbackForm}
                    />
                  ) : (
                    <MenuItem
                      onClick={() =>
                        window.alert(
                          isArchivedProject
                            ? getOrgTermsContent('archivedProjectMessage')
                            : 'The feedback form cannot be sent to participants because its dates are in the past. Please update the start and end dates and try again.'
                        )
                      }
                    >
                      <span className="flex">
                        <MailIcon />
                        <span>&nbsp;Send to New Participants</span>
                      </span>
                    </MenuItem>
                  )
                ) : null}
                <MenuItem divider />
              </span>
            ) : null}

            {survey && !isDateAfter ? (
              <AuthorizedAction
                action="update"
                subject={`${initiativeType}Initiative`}
              >
                <span className="item">
                  <MenuItem onClick={handleClickCopyLink} disabled={loading}>
                    <span className="flex">
                      <ShareIcon fill="#27B0E0" />
                      <span>&nbsp; Copy Sharing link</span>
                    </span>
                  </MenuItem>
                  <MenuItem divider />
                </span>
              </AuthorizedAction>
            ) : (
              <AuthorizedAction
                action="update"
                subject={`${initiativeType}Initiative`}
              >
                <MenuItem
                  onClick={() =>
                    window.alert(
                      isArchivedProject
                        ? getOrgTermsContent('archivedProjectMessage')
                        : 'The feedback form cannot be sent to participants because its dates are in the past. Please update the start and end dates and try again.'
                    )
                  }
                >
                  <span className="flex">
                    <ShareIcon fill="#27B0E0" />
                    <span>&nbsp; Copy Sharing link</span>
                  </span>
                </MenuItem>
                <MenuItem divider />
              </AuthorizedAction>
            )}

            {isAuthorized('update', 'survey', permissions) ||
            isAuthorized('destroy', 'survey', permissions) ? (
              <AuthorizedAction
                action="update"
                subject={`${initiativeType}Initiative`}
              >
                <span className="item">
                  <MenuItem
                    onClick={handleClickDeleteSurvey}
                    disabled={loading}
                  >
                    <span className="flex">
                      <DeleteBlueIcon />
                      <span>&nbsp; Delete</span>
                    </span>
                  </MenuItem>
                  <MenuItem divider />
                </span>
              </AuthorizedAction>
            ) : null}
          </React.Fragment>
        ) : null}
      </DropdownButton>
      <EditChangeInsightDatesModal
        changeInsightSettings={survey}
        initiative={initiative}
        showModal={showEditDatesModal}
        handleClose={() => setShowEditDatesModal(false)}
      />
    </div>
  );
};

export default ChangeInsightsActionDropdown;
